import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1300px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;

  h1 {
    text-align: left;
    margin-bottom: 30px;
    color: #000;
    width: 100%;
  }

  @media (max-width: 750px) {
    padding: 10px 20px;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 20px;
    }
  }
`;

export const ProfileContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .avatar-container {
    margin-bottom: 20px;
  }

  .info-container {
    width: 100%;
    margin-bottom: 30px;
    text-align: left;

    h2 {
        margin-bottom: 5px;
        color: #333;
        font-size: 24px;
    }

    p {
        color: #666;
        font-size: 16px;
        margin: 0;
    }
  }

  .actions {
    display: flex;
    justify-content: flex-start;
    gap: 15px;
  }
`;